import type { FC, ReactNode } from 'react';
import clsx from 'clsx';

export const BOLD_NAME = 'font-semibold';
export const LINK = 'relative font-medium text-primary-600 hover:text-primary-900';

export const bold = (text: string | null | undefined): ReactNode => <span className={BOLD_NAME}>{text ?? ''}</span>;

export const Summary: FC<{ children: ReactNode }> = ({ children }) => <div className="break-words">{children}</div>;

export const NameList: FC<{ names: string[] }> = ({ names }) => (
  <span>
    {names.map((name, idx, arr) => (
      <span key={name} className={clsx(BOLD_NAME, 'capitalize')}>
        {name}
        {idx < arr.length - 1 ? ', ' : ''}
      </span>
    ))}
  </span>
);
